import { Link } from "react-router-dom";
import { fileUrl, formatBRL } from "../lib/api";
import { MapPin, Star, Truck, Package, Confetti } from "@phosphor-icons/react";
import { describeListingPromos, unitLabelForItem, getListingPriceRange } from "../lib/pricing";

function deliveryBadge(regras_entrega) {
  if (regras_entrega === "eu_entrego" || regras_entrega === "ambos") {
    return {
      label: regras_entrega === "ambos" ? "Receba em casa ou Busque" : "Entregue em sua casa",
      icon: Truck,
      bg: "bg-emerald-500/95",
    };
  }
  return {
    label: "Você busca com o dono",
    icon: Package,
    bg: "bg-slate-700/95",
  };
}

export default function ListingCard({ item, testId }) {
  const img = item.thumbnails?.[0] || item.images?.[0];
  const badge = deliveryBadge(item.regras_entrega);
  const BadgeIcon = badge.icon;
  const promos = describeListingPromos(item);
  const priceRange = getListingPriceRange(item);
  const hasCaucao = !!item?.caucao?.active;
  const stockBlocked = !!item?._stock_blocked;
  return (
    <Link
      to={`/itens/${item.id}`}
      className={`aj-card overflow-hidden group block no-longpress ${stockBlocked ? "opacity-60 grayscale" : ""}`}
      onContextMenu={(e) => e.preventDefault()}
      data-testid={testId || `listing-card-${item.id}`}
    >
      <div className="aspect-square bg-slate-100 relative">
        {img ? (
          <img
            src={fileUrl(img)}
            alt={item.title}
            loading="lazy"
            decoding="async"
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-slate-400 text-xs">
            Sem foto
          </div>
        )}
        {stockBlocked && (
          <div className="absolute inset-0 flex items-center justify-center bg-black/60" data-testid="listing-stock-blocked-overlay">
            <span className="bg-red-600 text-white text-[10px] font-black uppercase tracking-wider px-2 py-1 rounded-full">
              Sem estoque nas datas
            </span>
          </div>
        )}
        <span
          className={`absolute top-2 left-2 ${badge.bg} text-white backdrop-blur px-2 py-0.5 rounded-full text-[10px] font-bold flex items-center gap-1`}
          data-testid="listing-delivery-badge"
        >
          <BadgeIcon size={11} weight="bold" />
          {badge.label}
        </span>
        {item.rating_count > 0 && (
          <span className="absolute top-2 right-2 bg-white/95 backdrop-blur px-1.5 py-0.5 rounded-full text-xs font-bold flex items-center gap-0.5">
            <Star size={11} weight="fill" color="#FFCC00" />
            {item.rating_avg.toFixed(1)}
          </span>
        )}
        {promos.hasPromo && (
          <span
            className="absolute bottom-2 left-2 bg-[#16A34A] text-white px-2 py-0.5 rounded-full text-[10px] font-black flex items-center gap-1 shadow-sm"
            data-testid="listing-promo-badge"
          >
            <Confetti size={11} weight="fill" /> Promoção
          </span>
        )}
      </div>
      <div className="p-3">
        <h3 className="font-heading font-bold text-sm leading-tight line-clamp-2 min-h-[2.5em] break-words hyphens-auto" title={item.title} lang="pt-BR">
          {item.title}
        </h3>
        <div className="flex items-center gap-1 text-xs text-slate-500 mt-1">
          <MapPin size={11} weight="bold" />
          <span className="truncate">{item.city}</span>
          {item.distance_km != null && (
            <span className="ml-auto text-[10px] font-semibold text-[#004E98]" data-testid="listing-distance">
              a {item.distance_km} km
            </span>
          )}
        </div>
        <div className="mt-2 flex items-baseline gap-1">
          {priceRange.hasRange && (
            <span className="text-[9px] font-bold text-slate-500 uppercase tracking-wider mr-0.5" data-testid="listing-price-from">
              A partir de
            </span>
          )}
          <div className="font-heading font-black text-lg text-[#004E98]">
            {formatBRL(priceRange.min)}
          </div>
          <div className="text-[10px] text-slate-500 uppercase tracking-wider font-semibold" data-testid="listing-price-unit">
            /{unitLabelForItem(item)[0]}
          </div>
        </div>
        {hasCaucao && (
          <div className="mt-1" data-testid="listing-caucao-badge">
            <span className="text-[9px] font-black text-amber-800 bg-amber-50 border border-amber-300 px-1.5 py-0.5 rounded-full inline-flex items-center gap-0.5">
              <Package size={9} weight="fill" /> Exige caução
            </span>
          </div>
        )}
        {(promos.cardBadge || promos.weekendBadge) && (
          <div className="mt-1.5 flex flex-wrap gap-1" data-testid="listing-promo-tags">
            {promos.cardBadge && (
              <span className="text-[9px] font-bold text-emerald-700 bg-emerald-50 border border-emerald-200 px-1.5 py-0.5 rounded-full">{promos.cardBadge}</span>
            )}
            {promos.weekendBadge && (
              <span className="text-[9px] font-bold text-[#FF6B35] bg-[#FF6B35]/10 border border-[#FF6B35]/30 px-1.5 py-0.5 rounded-full">{promos.weekendBadge}</span>
            )}
          </div>
        )}
      </div>
    </Link>
  );
}
